import generateUpc from './generateUpc'

export default {
    generateUpc,
}
